import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import PropTypes from 'prop-types';
import Dotdotdot from 'react-dotdotdot';

import * as ModalsActions from '../modals/ModalsActions';
import housingLogo from '../assets/img/houstingLogo.svg';
import realtorLogo from '../assets/img/realtorLogo.svg';
import './Style';

class FooterContainer extends Component {
    constructor(props) {
      super(props)

      this.state = {
        error: null,
        errorInfo: null,
        defaultDisclaimer: 'Any floor plans provided are not intended to be,'
            + ' nor should they be relied on as, official architectural drawings or '
            + ' similar renderings of a floor plan by a licensed, professional architect,'
            + ' engineer or other similar professional. This site is not responsible or'
            + ' liable for any acts or omissions created or the result of inaccurate'
            + ' measurements or placement of details within a floor plan rendering. It is'
            + ' recommended that persons interested in the exact floor plan of the property'
            + ' in question consult a licensed architect, engineer or check with the local'
            + ' government offices of the city in which the property is located for the'
            + ' official blue prints or architectural drawings of the property.'
            + '<br/>NY State Housing and Anti-Discrimination'
            + ' <a href="https://www.dos.ny.gov/licensing/docs/FairHousingNotice_new.pdf" target="_blank">Notice</a> and '
            + '<a href="https://www.dos.ny.gov/licensing/docs/2156.pdf" target="_blank">Disclosure</a>'
      }
    }

    componentDidCatch(error, errorInfo) {
        this.setState({
            error,
            errorInfo
        }, () => {
            console.error(error, errorInfo);
        })
    }

    render () {
        const {
            disclaimer,
            orderBottomLogo,
            poweredByLogo,
            housingLogoVisible,
            realtorLogoVisible,
            logoTime,
            showFpoBrand,
            tourMode
        } = this.props;
        const { defaultDisclaimer, error } = this.state;

        if (error) {
            return null;
        }

        const company_logo_url = poweredByLogo.url
            ? (
                <a href={poweredByLogo.url} target='_blank'>
                    <img src={poweredByLogo.logo + '?w=270&h=80'} alt="powered by logo"/>
                </a>
            )
            : (
                <img src={poweredByLogo.logo + '?w=270&h=80'} alt="powered by logo"/>
            );

        const companyLogoBlock = (poweredByLogo.logo && poweredByLogo.logo.length && +showFpoBrand)
            ? (
                <div className="company-logo-block">
                    <div className="company-logo-wrapper">
                        {company_logo_url}
                    </div>
                </div>
            )
            : null;

        const poweredByBlock = (orderBottomLogo.logo && 'r' != tourMode && +showFpoBrand)
            ? (
                <div className="powerder-by">
                    <p>with local service by:</p>
                </div>
            )
            : null;

        const subcompanyLogoBlock = (orderBottomLogo.logo && 'r' != tourMode && +showFpoBrand)
            ? orderBottomLogo.url
                ? (
                <div className="powered-by-logo">
                    <a href={orderBottomLogo.url} target='_blank'>
                        <img src={orderBottomLogo.logo + '?w=270&h=80&logoTime=' + logoTime} alt="agent logo"/>
                    </a>
                </div>
                )
                : (
                    <div className="powered-by-logo">
                        <img src={orderBottomLogo.logo + '?w=270&h=80&logoTime=' + logoTime} alt="agent logo"/>
                    </div>
                )
            : null;

        const disclaimerLinkBlock = (
                <span
                    className="disclaimer-link"
                    onClick={() => this.props.modalsActions.changeModalVisibility('modalDisclaimer', true)}>
                    Full disclaimer
                </span>
            );

        const disclaimerBlock = disclaimer.text
            ? (
                <div className="footer-disclaimer">
                    <Dotdotdot clamp={3}>
                        <p className='disclaimer custom' dangerouslySetInnerHTML={{__html:disclaimer.text}}></p>
                    </Dotdotdot>
                    {disclaimerLinkBlock}
                </div>
            )
            : (
                <div className="footer-disclaimer">
                    <Dotdotdot clamp={3}>
                        <p className='disclaimer' dangerouslySetInnerHTML={{__html:defaultDisclaimer}}></p>
                    </Dotdotdot>
                    {disclaimerLinkBlock}
                </div>
            );

            const getFamLogosBlock = (housingLogoVisible, realtorLogoVisible) => {
                if (!housingLogoVisible && !realtorLogoVisible) {
                    return null;
                }

                const housingLogoBlock = housingLogoVisible
                    ? (
                        <div className="housing-logo">
                            <img src={housingLogo} alt="housing logo"/>
                        </div>
                    )
                    : null;

                const realtorLogoBlock = realtorLogoVisible
                    ? (
                        <div className="realtor-logo">
                            <img src={realtorLogo} alt="realtor logo"/>
                        </div>
                    )
                    : null;

                return (
                    <div className="fam-logos">
                        {realtorLogoBlock}
                        {housingLogoBlock}
                    </div>
                );
            } ;

        return (
            <footer style={{justifyContent: +showFpoBrand ? "space-between" : "flex-end"}} className="footer-container">
                {companyLogoBlock}
                {poweredByBlock}
                {subcompanyLogoBlock}
                <div className="footer-copy">
                    {disclaimerBlock}
                    {getFamLogosBlock(housingLogoVisible, realtorLogoVisible)}
                </div>
            </footer>
        )
    }
}

FooterContainer.propTypes = {
    disclaimer: PropTypes.object.isRequired,
    orderBottomLogo: PropTypes.shape({
        logo: PropTypes.string,
        url: PropTypes.string
    }),
    poweredByLogo: PropTypes.shape({
        logo: PropTypes.string,
        url: PropTypes.string
    })
}


const mapStateToProps = (state) => {
    return {
        disclaimer: state.property.disclaimer,
        orderBottomLogo: state.app.orderBottomLogo,
        poweredByLogo: state.app.poweredByLogo,
        housingLogoVisible: state.app.housingLogoVisible,
        realtorLogoVisible: state.app.realtorLogoVisible,
        logoTime: state.agent.agentInfo.logoTime,
        showFpoBrand: state.agent.agentInfo.showFpoBrand,
        tourMode: state.app.tourMode
    }
}

const mapDispatchToProps = (dispatch) => ({
    modalsActions: bindActionCreators(ModalsActions, dispatch)
})


export default connect(mapStateToProps, mapDispatchToProps)(FooterContainer);
